var map = {
	"./1": 156,
	"./1.png": 156,
	"./2": 157,
	"./2.png": 157,
	"./3": 158,
	"./3.png": 158,
	"./4": 159,
	"./4.png": 159,
	"./about": 160,
	"./about.png": 160,
	"./activity": 278,
	"./activity.svg": 278,
	"./add-cta": 364,
	"./add-cta-active": 365,
	"./add-cta-active.svg": 365,
	"./add-cta.svg": 364,
	"./added-to-collections-active": 366,
	"./added-to-collections-active.svg": 366,
	"./adobe": 161,
	"./adobe.png": 161,
	"./analytics": 367,
	"./analytics.svg": 367,
	"./annotate": 368,
	"./annotate-active": 369,
	"./annotate-active.svg": 369,
	"./annotate.svg": 368,
	"./annotate/arrow": 326,
	"./annotate/arrow.svg": 326,
	"./annotate/crop": 327,
	"./annotate/crop.svg": 327,
	"./annotate/draw": 328,
	"./annotate/draw.svg": 328,
	"./annotate/ellipse": 329,
	"./annotate/ellipse-focus": 330,
	"./annotate/ellipse-focus.svg": 330,
	"./annotate/ellipse.svg": 329,
	"./annotate/emoji": 143,
	"./annotate/emoji.png": 143,
	"./annotate/emoji@2x": 144,
	"./annotate/emoji@2x.png": 144,
	"./annotate/emoji@3x": 145,
	"./annotate/emoji@3x.png": 145,
	"./annotate/highlighter": 331,
	"./annotate/highlighter.svg": 331,
	"./annotate/line": 332,
	"./annotate/line.svg": 332,
	"./annotate/number": 333,
	"./annotate/number.svg": 333,
	"./annotate/pixelate": 334,
	"./annotate/pixelate.svg": 334,
	"./annotate/rect": 335,
	"./annotate/rect.svg": 335,
	"./annotate/square-focus": 336,
	"./annotate/square-focus.svg": 336,
	"./annotate/text": 337,
	"./annotate/text.svg": 337,
	"./annotate/tools-history-back": 338,
	"./annotate/tools-history-back-disabled": 339,
	"./annotate/tools-history-back-disabled.svg": 339,
	"./annotate/tools-history-back.svg": 338,
	"./annotate/tools-history-forward": 340,
	"./annotate/tools-history-forward-disabled": 341,
	"./annotate/tools-history-forward-disabled.svg": 341,
	"./annotate/tools-history-forward.svg": 340,
	"./annotate/tools-zoom-zoom-in": 321,
	"./annotate/tools-zoom-zoom-in.svg": 321,
	"./annotate/tools-zoom-zoom-out": 322,
	"./annotate/tools-zoom-zoom-out.svg": 322,
	"./app-icon": 370,
	"./app-icon.svg": 370,
	"./apple": 371,
	"./apple.svg": 371,
	"./apple_logo": 264,
	"./apple_logo.svg": 264,
	"./arrow-big": 162,
	"./arrow-big.png": 162,
	"./atlassian": 163,
	"./atlassian.png": 163,
	"./bg-bottom": 164,
	"./bg-bottom.png": 164,
	"./bg-top": 165,
	"./bg-top.png": 165,
	"./bill": 372,
	"./bill.svg": 372,
	"./blurred-drop": 112,
	"./blurred-drop.png": 112,
	"./branding": 323,
	"./branding.svg": 323,
	"./buttons-add-new-collection-hover": 373,
	"./buttons-add-new-collection-hover.svg": 373,
	"./buttons-add-new-collection-sidebar": 374,
	"./buttons-add-new-collection-sidebar.svg": 374,
	"./card-generic": 134,
	"./card-generic.png": 134,
	"./check-mark": 375,
	"./check-mark.svg": 375,
	"./checkmark": 376,
	"./checkmark.svg": 376,
	"./checkmark@2x": 166,
	"./checkmark@2x.png": 166,
	"./chrome": 377,
	"./chrome.svg": 377,
	"./close": 344,
	"./close-icon": 219,
	"./close-icon.svg": 219,
	"./close.svg": 344,
	"./cloud-loader": 303,
	"./cloud-loader.gif": 303,
	"./cloudapp": 167,
	"./cloudapp-favicon": 168,
	"./cloudapp-favicon.png": 168,
	"./cloudapp-icon": 169,
	"./cloudapp-icon.png": 169,
	"./cloudapp-logo-horizontal": 324,
	"./cloudapp-logo-horizontal.svg": 324,
	"./cloudapp.png": 167,
	"./coach-mark": 378,
	"./coach-mark.svg": 378,
	"./collection": 246,
	"./collection.svg": 246,
	"./conversation": 379,
	"./conversation.svg": 379,
	"./dashboard": 279,
	"./dashboard.svg": 279,
	"./download-arrow": 380,
	"./download-arrow.svg": 380,
	"./download-chrome": 381,
	"./download-chrome.svg": 381,
	"./download-cloud": 382,
	"./download-cloud.svg": 382,
	"./download-drop": 383,
	"./download-drop.svg": 383,
	"./download-mac": 384,
	"./download-mac.svg": 384,
	"./download-windows": 385,
	"./download-windows.svg": 385,
	"./download_icon_chrome": 386,
	"./download_icon_chrome.svg": 386,
	"./download_icon_mac": 387,
	"./download_icon_mac.svg": 387,
	"./download_icon_windows": 388,
	"./download_icon_windows.svg": 388,
	"./email": 265,
	"./email.svg": 265,
	"./enterprise@2x": 170,
	"./enterprise@2x.png": 170,
	"./file-placeholder": 342,
	"./file-placeholder.svg": 342,
	"./free@2x": 171,
	"./free@2x.png": 171,
	"./free_plan_icon": 172,
	"./free_plan_icon.png": 172,
	"./gift": 304,
	"./gift.svg": 304,
	"./google_logo": 389,
	"./google_logo.svg": 389,
	"./hat-icon": 390,
	"./hat-icon.svg": 390,
	"./hero-asset": 120,
	"./hero-asset.gif": 587,
	"./hero-asset.png": 120,
	"./icon-clock": 266,
	"./icon-clock.jpeg": 266,
	"./icon-get-cloudapp": 220,
	"./icon-get-cloudapp.svg": 220,
	"./icon-google": 267,
	"./icon-google.svg": 267,
	"./icon-muted": 343,
	"./icon-muted.svg": 343,
	"./icon-muted@2x": 173,
	"./icon-muted@2x.png": 173,
	"./icon-padlock": 221,
	"./icon-padlock.svg": 221,
	"./icons-add": 305,
	"./icons-add-bordered": 174,
	"./icons-add-bordered.png": 174,
	"./icons-add-to-collection-solid": 391,
	"./icons-add-to-collection-solid.svg": 391,
	"./icons-add.svg": 305,
	"./icons-announcement": 392,
	"./icons-announcement.svg": 392,
	"./icons-bug": 393,
	"./icons-bug.svg": 393,
	"./icons-card-actions-compact-read-only": 135,
	"./icons-card-actions-compact-read-only.svg": 135,
	"./icons-clipboard": 289,
	"./icons-clipboard-2": 290,
	"./icons-clipboard-2.svg": 290,
	"./icons-clipboard.svg": 289,
	"./icons-close": 320,
	"./icons-close.svg": 320,
	"./icons-conversation": 140,
	"./icons-conversation.svg": 140,
	"./icons-download-bordered": 175,
	"./icons-download-bordered.png": 175,
	"./icons-download-solid": 394,
	"./icons-download-solid.svg": 394,
	"./icons-edit-minimal": 268,
	"./icons-edit-minimal.svg": 268,
	"./icons-embed-bordered": 176,
	"./icons-embed-bordered.png": 176,
	"./icons-embed-solid": 395,
	"./icons-embed-solid.svg": 395,
	"./icons-hidden": 396,
	"./icons-hidden.svg": 396,
	"./icons-invite-active": 280,
	"./icons-invite-active.svg": 280,
	"./icons-invite-default": 281,
	"./icons-invite-default.svg": 281,
	"./icons-locked-bordered": 177,
	"./icons-locked-bordered.png": 177,
	"./icons-magic": 397,
	"./icons-magic.svg": 397,
	"./icons-mouse-click": 398,
	"./icons-mouse-click-gray": 399,
	"./icons-mouse-click-gray.svg": 399,
	"./icons-mouse-click.svg": 398,
	"./icons-new": 178,
	"./icons-new-gray": 306,
	"./icons-new-gray.svg": 306,
	"./icons-new-transparent": 307,
	"./icons-new-transparent.svg": 307,
	"./icons-new-white": 308,
	"./icons-new-white.svg": 308,
	"./icons-new.svg": 178,
	"./icons-notifications": 141,
	"./icons-notifications-active": 142,
	"./icons-notifications-active.svg": 142,
	"./icons-notifications.svg": 141,
	"./icons-premium-star": 309,
	"./icons-premium-star.svg": 309,
	"./icons-rainbow-circle": 179,
	"./icons-rainbow-circle.png": 179,
	"./icons-rounded-corners": 400,
	"./icons-rounded-corners.svg": 400,
	"./icons-sales": 401,
	"./icons-sales.svg": 401,
	"./icons-search": 402,
	"./icons-search.svg": 402,
	"./icons-settings-blue": 310,
	"./icons-settings-blue.svg": 310,
	"./icons-settings-gray": 269,
	"./icons-settings-gray.svg": 269,
	"./icons-share-settings-locked": 403,
	"./icons-share-settings-locked.svg": 403,
	"./icons-slightly-rounded-corners": 404,
	"./icons-slightly-rounded-corners.svg": 404,
	"./icons-square-corners": 405,
	"./icons-square-corners.svg": 405,
	"./icons-support": 406,
	"./icons-support.svg": 406,
	"./icons-toggle-close": 311,
	"./icons-toggle-close.svg": 311,
	"./icons-toggle-open": 312,
	"./icons-toggle-open.svg": 312,
	"./icons-transcribe": 270,
	"./icons-transcribe.svg": 270,
	"./illustrations-transcription-processing": 313,
	"./illustrations-transcription-processing.svg": 313,
	"./indicator-right": 407,
	"./indicator-right.svg": 407,
	"./infinite": 325,
	"./infinite.svg": 325,
	"./installer": 408,
	"./installer.svg": 408,
	"./integrations": 282,
	"./integrations.svg": 282,
	"./loader": 409,
	"./loader.svg": 409,
	"./logo-visa": 410,
	"./logo-visa.jpeg": 410,
	"./logo@2x": 180,
	"./logo@2x-blue": 181,
	"./logo@2x-blue.png": 181,
	"./logo@2x.png": 180,
	"./logos-cloud-app-logomark-full-color": 314,
	"./logos-cloud-app-logomark-full-color.svg": 314,
	"./main-banner": 182,
	"./main-banner.png": 182,
	"./markers/m_0": 411,
	"./markers/m_0.svg": 411,
	"./markers/m_1": 412,
	"./markers/m_1.svg": 412,
	"./markers/m_2": 413,
	"./markers/m_2.svg": 413,
	"./markers/m_3": 414,
	"./markers/m_3.svg": 414,
	"./markers/m_4": 415,
	"./markers/m_4.svg": 415,
	"./markers/m_5": 416,
	"./markers/m_5.svg": 416,
	"./markers/m_6": 417,
	"./markers/m_6.svg": 417,
	"./markers/m_7": 418,
	"./markers/m_7.svg": 418,
	"./markers/m_8": 419,
	"./markers/m_8.svg": 419,
	"./markers/m_9": 420,
	"./markers/m_9.svg": 420,
	"./menu-bar": 421,
	"./menu-bar.svg": 421,
	"./microsoft_teams_logo": 422,
	"./microsoft_teams_logo.svg": 422,
	"./new_annotate/move": 423,
	"./new_annotate/move.svg": 423,
	"./onboarding/apple": 222,
	"./onboarding/apple.svg": 222,
	"./onboarding/bill": 183,
	"./onboarding/bill.svg": 183,
	"./onboarding/chrome": 223,
	"./onboarding/chrome.svg": 223,
	"./onboarding/download-arrow": 224,
	"./onboarding/download-arrow.svg": 224,
	"./onboarding/download-chrome": 225,
	"./onboarding/download-chrome.svg": 225,
	"./onboarding/download-drop": 226,
	"./onboarding/download-drop.svg": 226,
	"./onboarding/download-mac": 227,
	"./onboarding/download-mac.svg": 227,
	"./onboarding/download-windows_color": 228,
	"./onboarding/download-windows_color.svg": 228,
	"./onboarding/email": 184,
	"./onboarding/email.svg": 184,
	"./onboarding/hat-icon": 229,
	"./onboarding/hat-icon.svg": 229,
	"./onboarding/icons-check": 136,
	"./onboarding/icons-check.svg": 136,
	"./onboarding/icons-chrome": 230,
	"./onboarding/icons-chrome.svg": 230,
	"./onboarding/icons-download": 185,
	"./onboarding/icons-download.svg": 185,
	"./onboarding/icons-extension": 186,
	"./onboarding/icons-extension.svg": 186,
	"./onboarding/icons-mac-os-app": 121,
	"./onboarding/icons-mac-os-app.png": 121,
	"./onboarding/icons-record": 187,
	"./onboarding/icons-record.svg": 187,
	"./onboarding/in-browser-icon": 231,
	"./onboarding/in-browser-icon.svg": 231,
	"./onboarding/installer": 232,
	"./onboarding/installer.svg": 232,
	"./onboarding/menu-bar": 233,
	"./onboarding/menu-bar.svg": 233,
	"./onboarding/start": 188,
	"./onboarding/start.svg": 188,
	"./onboarding/windows": 234,
	"./onboarding/windows.svg": 234,
	"./onboarding/zight-logomark-600-600": 235,
	"./onboarding/zight-logomark-600-600.svg": 235,
	"./parallax": 424,
	"./parallax.jpg": 424,
	"./pattern": 189,
	"./pattern-2": 190,
	"./pattern-2.png": 190,
	"./pattern-4": 191,
	"./pattern-4.png": 191,
	"./pattern.png": 189,
	"./plus": 425,
	"./plus-small": 426,
	"./plus-small.svg": 426,
	"./plus.svg": 425,
	"./prize": 427,
	"./prize.svg": 427,
	"./prize@2x": 123,
	"./prize@2x.png": 123,
	"./pro-badge": 236,
	"./pro-badge.svg": 236,
	"./pro-ribbon": 103,
	"./pro-ribbon.png": 103,
	"./pro-ribbon.svg": 588,
	"./pro@1x": 192,
	"./pro@1x.png": 192,
	"./pro@2x": 137,
	"./pro@2x.png": 137,
	"./pro@3x": 193,
	"./pro@3x.png": 193,
	"./pro_plan_icon": 194,
	"./pro_plan_icon.png": 194,
	"./salesforce": 195,
	"./salesforce.png": 195,
	"./seats-left": 428,
	"./seats-left.svg": 428,
	"./slack-icon": 196,
	"./slack-icon.png": 196,
	"./slack_logo": 271,
	"./slack_logo.svg": 271,
	"./social-proof-image": 272,
	"./social-proof-image.jpeg": 272,
	"./spinner": 61,
	"./spinner.svg": 61,
	"./star_active": 429,
	"./star_active.svg": 429,
	"./star_default": 430,
	"./star_default.svg": 430,
	"./star_hover": 431,
	"./star_hover.svg": 431,
	"./start": 432,
	"./start.svg": 432,
	"./team": 273,
	"./team-3": 433,
	"./team-3.jpg": 433,
	"./team.svg": 273,
	"./team@2x": 138,
	"./team@2x.png": 138,
	"./team_plan_icon": 146,
	"./team_plan_icon.png": 146,
	"./team_sidebar": 197,
	"./team_sidebar.png": 197,
	"./thumbnail": 198,
	"./thumbnail.png": 198,
	"./upload-arrow": 434,
	"./upload-arrow.svg": 434,
	"./upload-cloud": 435,
	"./upload-cloud.svg": 435,
	"./upload-copy": 199,
	"./upload-copy.png": 199,
	"./upload-copy@2x": 200,
	"./upload-copy@2x.png": 200,
	"./upload-copy@3x": 201,
	"./upload-copy@3x.png": 201,
	"./upload-drop": 436,
	"./upload-drop.svg": 436,
	"./video-thumbnail": 202,
	"./video-thumbnail.png": 202,
	"./video-trim": 437,
	"./video-trim-active": 438,
	"./video-trim-active.svg": 438,
	"./video-trim.svg": 437,
	"./view-grid": 439,
	"./view-grid-active": 440,
	"./view-grid-active.svg": 440,
	"./view-grid.svg": 439,
	"./view-list": 441,
	"./view-list-active": 442,
	"./view-list-active.svg": 442,
	"./view-list.svg": 441,
	"./windows": 443,
	"./windows.svg": 443,
	"./your_plan_badge@2x": 203,
	"./your_plan_badge@2x.png": 203,
	"./zendesk": 204,
	"./zendesk.png": 204,
	"./zight-favicon": 205,
	"./zight-favicon.png": 205,
	"./zight-logo-160-36": 274,
	"./zight-logo-160-36.svg": 274,
	"./zight-logo-180-41": 275,
	"./zight-logo-180-41.svg": 275,
	"./zight-logo-dashboard": 444,
	"./zight-logo-dashboard.svg": 444,
	"./zight-logomark": 283,
	"./zight-logomark-600-600": 315,
	"./zight-logomark-600-600.svg": 315,
	"./zight-logomark-white": 445,
	"./zight-logomark-white.svg": 445,
	"./zight-logomark.svg": 283
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 532;